import { combineReducers } from 'redux';

import listaPaises from './listaPaises/reducer';

export default combineReducers({
	listaPaises,
});
